const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    stroke: "#969899",
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 24.001302 12 C 24.001302 18.629774 18.629774 24.001302 12 24.001302 C 5.370226 24.001302 -0.00130208 18.629774 -0.00130208 12 C -0.00130208 5.370226 5.370226 -0.00130208 12 -0.00130208 C 18.629774 -0.00130208 24.001302 5.370226 24.001302 12 Z M 24.001302 12 ",
    transform: "matrix(0.692308,0,0,0.692308,0.692308,0.692308)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#969899",
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 9.088542 8.998264 C 9.573785 7.621528 10.984375 6.792101 12.428819 7.040365 C 13.867622 7.288628 14.922743 8.53559 14.922743 10.002604 C 14.922743 12 11.921007 12.998698 11.921007 12.998698 ",
    transform: "matrix(0.692308,0,0,0.692308,0.692308,0.692308)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#969899",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fillOpacity: 1
    },
    d: "M 9 11.769531 C 9.382812 11.769531 9.691406 12.078125 9.691406 12.460938 C 9.691406 12.84375 9.382812 13.152344 9 13.152344 C 8.617188 13.152344 8.308594 12.84375 8.308594 12.460938 C 8.308594 12.078125 8.617188 11.769531 9 11.769531 Z M 9 11.769531 "
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelp);
export default __webpack_public_path__ + "static/media/icon-help.a88f99e3.svg";
export { ForwardRef as ReactComponent };